module.exports = __webpack_public_path__ + "img/logo.039c4476.png";